import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CarpentryDistrictBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.CARPENTRY_DISTRICT;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default CarpentryDistrictBuildingTileEntity;
